import { render } from "./InstiRequests.vue?vue&type=template&id=68088602&scoped=true"
import script from "./InstiRequests.vue?vue&type=script&lang=js"
export * from "./InstiRequests.vue?vue&type=script&lang=js"

import "./InstiRequests.vue?vue&type=style&index=0&id=68088602&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68088602"]])

export default __exports__